<template>
    <b-card :header="uLang('app.next_trajectory')" header-tag="h4" class="latest-trajectory bg-default-card">
        <rea-loader :loading="loading"></rea-loader>
        <table class="next-action-document-table table">
            <tr>
                <td width="150">{{ uLang('app.trajectory') }} {{ lang('app.name') }}:</td>
                <td>{{ cardData.trajectory.name }}</td>
            </tr>
            <tr>
                <td>{{ uLang('app.trajectory') }} {{ lang('app.description') }}:</td>
                <td>{{ cardData.trajectory.description }}</td>
            </tr>
            <tr>
                <td>{{ uLang('app.candidate') }}:</td>
                <td>{{ cardData.relation.full_name }}</td>
            </tr>
        </table>
        <button
            class="btn btn-brand"
            v-if="cardData.relation.id && cardData.id && cardData.milestone_progresses[0].id"
            @click.prevent="$router.push({
                name: 'admin.relations.trajectory-enrolments.milestone-progresses.view',
                params: {
                    'relationId': cardData.relation.id,
                    'trajectoryEnrolmentId': cardData.id,
                    'milestoneProgressId': cardData.milestone_progresses[0].id,
                }
            })">
            {{ uLang('app.go_to_overview') }}
        </button>
    </b-card>
</template>
<script>
import { ReaLoader } from '~/components/helpers'
export default {
    name: 'FirstUpcomingActionDocument',

    components: {
        ReaLoader
    },

    props: {
        actionDocument: {
            required: true,
        },
        loading: {
            required: true,
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            emptyPanel: {
                'trajectory': {
                    'name': uLang('app.no_trajectory'),
                    'description': uLang('app.no_description'),
                },
                'relation': {
                    'id': 1,
                    'full_name': uLang('app.no_name'),
                },
                'milestone_progresses': [
                    {
                        id: 1
                    }
                ],
                'href': '#',
            },
        }
    },

    methods: {

    },

    computed: {
        cardData: function() {
            if(_.isEmpty(this.actionDocument)) {
                return this.emptyPanel
            }

            return this.actionDocument
        }
    }
}
</script>
<style lang="scss">
    table.next-action-document-table {
        tr:first-child {
            td, th {
                text-align: left;
                border-top: none;
            }
        }
        td {
            padding-left: 0px !important;
        }

    }
    .action_icon {
        color: #5A4587 !important;
    }
    .action_icon:hover {
        color: lighten(#5A4587, 25%) !important;
    }

    .card-block {
        position: relative;
    }
</style>
